<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="subtitle-1"> Print Products </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-divider />
      <v-data-table
        disable-pagination
        hide-default-footer
        disable-sort
        :headers="[
          { text: '', value: 'actions' },
          { text: 'Mailing', value: 'mailingEnabled' },
          { text: 'Print Product', value: 'name' },
          { text: 'Category', value: 'category' },
          { text: 'Material', value: 'material.display' },
          { text: 'Display', value: 'material_category_name' },
          { text: 'Provider', value: 'providerId' }
        ]"
        :items="available"
      >
        <template #[`item.mailingEnabled`]="{ item }">
          <LoadingSpinner
            v-if="mailingPending.includes(item.id)"
            :size="20"
            :width="2"
          />
          <v-icon
            v-else
            color="primary"
            @click="setMailingEnabled(item.id, !item.mailingEnabled)"
          >
            {{ item.mailingEnabled ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </template>
        <template #[`item.material_category_name`]="{ item }">
          {{
            materials
              .filter((x) => x.id == item.material.id)
              .map((x) => x.names)[0]
              .filter((x) => x.categoryId == product.category.id)
              .map((x) => x.text)[0]
          }}
        </template>
        <template #[`item.providerId`]="{ item }">
          {{ provider_name(item.providerId) }}
        </template>
        <template #[`item.actions`]="{ item }">
          <LoadingSpinner
            v-if="connectionPending.includes(item.id)"
            :size="20"
            :width="2"
          />
          <v-icon
            v-else-if="selected.filter((x) => x.id == item.id).length"
            color="primary"
            @click="disconnect(item.id)"
          >
            check_box
          </v-icon>
          <v-icon
            v-else
            color="primary"
            @click="connect(item.id)"
          >
            check_box_outline_blank
          </v-icon>
        </template>
      </v-data-table>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { mapGetters } from 'vuex';
import { sortBy } from 'lodash';

export default {
  name: 'ProductPrints',
  data() {
    return {
      connectionPending: [],
      mailingPending: []
    };
  },
  computed: {
    available() {
      return sortBy(
        this.possible(this.product.width, this.product.height).map((x) =>
          Object.assign(x, {
            mailingEnabled: this.product.snailblastPrintProductIds.includes(x.id)
          })
        ),
        'material.display'
      );
    },
    selected() {
      return this.connected(this.product.id);
    },
    ...mapGetters({
      product: 'products/product',
      connected: 'print/connected',
      possible: 'print/available',
      all_print_products: 'print/list',
      provider_name: 'lookup/print_provider_name',
      materials: 'print/materials'
    })
  },
  methods: {
    disconnect(printProductId) {
      if (this.connectionPending.includes(printProductId)) return;
      this.connectionPending.push(printProductId);
      this.$store
        .dispatch('print/disconnect', {
          printProductId,
          coreProductId: this.product.id
        })
        .then(() => {
          this.$root.$snackbarSuccess('Print option disconnected');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.connectionPending = this.connectionPending.filter((id) => id !== printProductId);
        });
    },

    connect(printProductId) {
      if (this.connectionPending.includes(printProductId)) return;
      this.connectionPending.push(printProductId);
      this.$store
        .dispatch('print/connect', {
          printProductId,
          coreProductId: this.product.id
        })
        .then(() => {
          this.$root.$snackbarSuccess('Print option connected');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.connectionPending = this.connectionPending.filter((id) => id !== printProductId);
        });
    },
    setMailingEnabled(printProductId, mailable) {
      if (this.mailingPending.includes(printProductId)) return;
      this.mailingPending.push(printProductId);
      this.$store
        .dispatch('products/setPrintProductMailable', {
          id: this.product.id,
          printProductId: printProductId,
          mailable: mailable
        })
        .then(() => {
          this.$root.$snackbarSuccess('Mailing enabled');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.mailingPending = this.mailingPending.filter((id) => id !== printProductId);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-input__append-outer {
  margin: 0 !important;
  margin-left: 10px !important;
  height: 40px;
}
</style>
